import { useEffect } from 'react'
import { NextRouter } from 'next/router'

import { EventDetectionMethod, EventType } from '~/behavior-tracking/types'
import { logUserActivity } from '~/behavior-tracking/utility/view-event-logs.utility'

const PULSE_INTERVAL = 30_000

export default function useUserPulseTracker(router: NextRouter, userId: number | null): void {
  useEffect(() => {
    const intervalId = setInterval(async () => {
      if (userId == null) {
        return
      }

      if (document.hidden) {
        return
      }

      const event = {
        eventName: EventType.PULSE,
        viewKey: router.asPath,
        extra: {
          detectBy: EventDetectionMethod.PULSE_INTERVAL_EVENT,
        },
      }

      await logUserActivity(userId, event)
    }, PULSE_INTERVAL)

    return () => {
      clearInterval(intervalId)
    }
  }, [router.asPath, userId])
}
